import { getEnumValues } from './get-enum-values';
export enum StatisticType{
	Starting='starting',
	Standard='standard'
	// Template='template',
	// GlobalTemplate='global-template',
}
export const StatisticTypeValues = getEnumValues <StatisticType>(StatisticType)